/*
 * Copyright © 2020-2023 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: garry彭
 * @LastEditTime: 2024-03-01 17:54:40
 */
import React, { useEffect, useState } from 'react'
import { Modal } from 'antd'
import styles from './index.module.scss'
import { registeWebPopup } from '../../../utils/sensors'
import { useAppDispatch, useAppSelector } from '../../../app/hooks'
import {
  reportNotice,
  setHasNewNotify,
  toViewAction
} from '../../../actions/main'
import sensors from '../../../utils/sensors'

interface PopupConfig {
  toView?: any
  imgUrl?: string
  closeIconUrl?: string
  expireTime?: number
  noticeContent?: string
}

interface PlanInfo {
  planId?: string
  name?: string
}

const OperationModal: React.FC = () => {
  const [visible, setVisible] = useState(false)
  const [config, setConfig] = useState<PopupConfig>({})
  const [plan, setPlan] = useState<PlanInfo>({})
  const dispatch = useAppDispatch()
  const userID = useAppSelector((state) => state.main.user?.user_id)
  const groupID = useAppSelector((state) => state.group.groupId)

  const handleClick = () => {
    const { toView } = config

    sensors.track('web_get_action_pop_notification', {
      groupID,
      actionType: 'clickPic',
      functionID: plan.planId,
      functionName: plan.name
    })

    dispatch(toViewAction(toView))
    setVisible(false)
  }

  const handleClose = () => {
    setVisible(false)
  }

  useEffect(() => {
    registeWebPopup((data) => {
      dispatch(
        reportNotice({
          userID,
          expireTime: data.content.expireTime,
          noticeContent: data.content.noticeContent,
          toView: JSON.stringify(data.content.toView),
          sensor_plan_id: data.planId,
          sensor_plan_name: data.name
        })
      ).then((res) => {
        if (res.isNewNotice) {
          dispatch(setHasNewNotify(true))
        }
      })

      setConfig(data.content)
      setPlan({
        planId: data.planId,
        name: data.name
      })
      setVisible(true)

      sensors.track('web_get_action_pop_notification', {
        groupID,
        actionType: 'showPop',
        functionID: data.planId,
        functionName: data.name
      })
    })
  }, [])

  return (
    <Modal
      open={visible}
      footer={null}
      closable={false}
      styles={{
        body: {
          padding: 0,
          cursor: 'pointer'
        }
      }}
    >
      <div className={styles.modal}>
        <img
          alt=""
          src={config.imgUrl}
          style={{
            width: '100%'
          }}
          onClick={handleClick}
        />

        <img
          src={config.closeIconUrl}
          alt=""
          className={styles.close}
          onClick={handleClose}
        />
      </div>
    </Modal>
  )
}

export default OperationModal
